module.exports = __webpack_public_path__ + "static/assets/95ae02512eb2280da0b1eb0711ec948c.gif";